import {
  ADD_NEW_FOOD_MEAL_PLANNER,
  ADD_UPDATE_MEAL_PLANNER,
  MEAL_PLAN_PAGE_BARCODE_READ,
  MEAL_PLAN_PAGE_BARCODE_READ_IMG,
  CLEAR_MEALPLANNER_FORM,
  CLEAR_PLANNER,
  DELETE_FOOD_MEAL_PLANNER,
  GET_ITEM_DETAILS,
  getEnded,
  getFailed,
  getStarted,
  getSucceeded,
  IS_UNSAVED,
  LIST_COMBINE_MEAL_PLANNER,
  MEAL_ITEM_CLICK_MEALPALNNER,
  MEAL_PLANNER_INITIALIZATION,
  ON_CHANGE_ALERT_STATUS,
  ON_CHANGE_MEALPLANNERFORM,
  ON_SELECT_ITEM_TO_DELETE,
  PARTIAL_RESULT_FOUND,
  TOGGLE_UNSAVE_MESSAGE,
  Unsaved_Data_Checker,
  ADD_GREY_UPC_ITEM_NAME_FIELD,
  RESET_CONTRIBUTE_ALERT_STATE,
  MEAL_PLANNER_SET_LOADING,
} from "../actions/constant";
import moment from "moment";
import { uuidv4 } from "../services/PublicService";
import i18n from "../i18n";
//import { NUTRIENTS_LIST } from "../pages/Constants";
//import { isNull } from "util";

const initialState = {
  planId: undefined,
  updateMode: false,
  previousUpdateMode: false,
  replaceValertShowStatus: false,
  mealPlannerForm: { meals: "all", counterState: 0 },
  mealListAll: [],
  is_custom: false,
  mealListShow: [],
  BaseNutrientsList: [],
  nutritionsList: [],
  typeAheadSearchOptions: [],
  typeAheadSearchObjects: [],
  dropDownList: [
    { value: "all", label: "All" },
    { value: "breakfast", label: "Breakfast" },
    { value: "lunch", label: "Lunch" },
    { value: "dinner", label: "Dinner" },
    { value: "supper", label: "Supper" },
    { value: "snack1", label: "Snack 1" },
    { value: "snack2", label: "Snack 2" },
    { value: "snack3", label: "Snack 3" },
  ],
  isLoading: true,
  disabled: {
    newMeal: true,
    addBtn: true,
    savePageBtn: true,
    updatePageBtn: true,
    meals: true,
  },
  saveSuccess: false,
  counterState: 0,
  firstChange: false,
  servingSize: 0,
  barcodeValue: "",
  addCustomAlert: false,
  previousSelectedItems: {},
  saveError: { type: null, meta: [] },
};

function showServingSize(allItems) {
  let selectedItems = allItems.filter((item) => item.isSelected);
  let servingSize = 0;
  selectedItems.map((item) => {
    servingSize +=
      item.food.convert_size && item.food.convert_size != null
        ? Number(item.food.convert_size)
        : 0;
  });
  return servingSize;
}

function hasCustom(allItems) {
  let selectedItems = allItems.filter((item) => item.isSelected);
  let hasCustom = selectedItems.filter((item) => {
    const itemID = item.food._id ? item.food._id.slice(0, 1) : "";
    if (item.food.is_custom || ((itemID === "6" || itemID === "") && item.food.upc) || itemID === "") {
      return true;
    }
    // Otherwise, exclude the item
    return false;
  });

  if (hasCustom.length > 0) {
    return true;
  } else {
    return false;
  }
}

function showingNutrientsArea(baseNutrientsList = [], allItems) {
  let selectedItems = allItems.filter((item) => item.isSelected);
  let nutList = [...baseNutrientsList];
  nutList.forEach((nut) => {
    let sum = 0;
    let fillItems = [];
    selectedItems.forEach((selIt) => {
      let selItcheck = {};
      if (selIt.food.nutrients) {
        selItcheck = selIt.food.nutrients.filter((nutf) => nutf._id == nut._id);
      }
      if (selItcheck && selItcheck.length > 0) {
        //fillItems.push(selIt);
        sum = sum + selItcheck[0].size;
      }
    });
    // nut.sum = twoDecimals(sum);

    if (sum == 0) {
      nut.sum = 0;
    } else if (sum != 0 && sum < 1) {
      nut.sum = sum.toPrecision(2);
    } else if (sum >= 1 && sum < 100) {
      nut.sum = sum.toFixed(1);
    } else if (sum >= 100) {
      nut.sum = Math.floor(sum);
    }

    if (nut.max > 0) {
      nut.percentage = ((nut.sum * 100) / nut.max).toFixed();
    } else {
      nut.percentage = "N/A";
    }

    // Mark bold & indent flags for styling in the UI
    const BOLD_IDS = new Set([
      "1400600000001000001", // Calorie
      "1400600000001000002", // Total Fat
      "1400600000001000056", // Cholesterol
      "1400600000001000061", // Sodium
      "1400600000001000062", // Total Carbohydrate
      "1400600000001000083", // Protein
    ]);
    const INDENT_IDS = new Set([
      "1400600000001000003", // Saturated Fat
      "1400600000001000018", // Trans Fat
      "1400600000001000063", // Dietary Fiber
      "1400600000001000067", // Sugars
    ]);

    if (BOLD_IDS.has(nut._id)) nut.bold = true;
    if (INDENT_IDS.has(nut._id)) nut.ind = 1;   // 1 means "indent this line"
  });
  return nutList;
}

function showingGrid(allItems, meal) {
  allItems.map((item) => {
    item.vId = item.vId ? item.vId : uuidv4();
  });
  var showList = [];
  if (meal != "all") {
    showList = allItems.filter((item) => item.meal == meal);
  } else {
    showList = allItems;
  }
  return showList;
}

function disableChecker(state) {
  let disabled = {
    newMeal: true,
    addBtn: true,
    savePageBtn: true,
    updatePageBtn: true,
    meals: !state.mealPlannerForm.time,
  };

  const mealForm = state.mealPlannerForm;
  const hasMeals =
    mealForm.meals && mealForm.meals !== "null" && mealForm.meals !== "all";
  const hasNewMeal = mealForm.newMeal && mealForm.newMeal.trim().length > 0;

  if (mealForm.time && state.mealListAll.length > 0 && !state.updateMode) {
    disabled.savePageBtn = false;
  }

  if (state.updateMode && mealForm.time) {
    disabled.updatePageBtn = !state.firstChange;
    IS_UNSAVED(state.firstChange ? "yes" : "no");

    if (hasMeals) {
      disabled.newMeal = false;
    }
  }

  if (hasMeals || hasNewMeal) {
    disabled.newMeal = !hasMeals;
    disabled.addBtn = !hasNewMeal;
  }

  if (
    (state.updateMode && !disabled.updatePageBtn) ||
    (!state.updateMode && !disabled.savePageBtn)
  ) {
    IS_UNSAVED("yes");
    unsavedData();
  } else {
    IS_UNSAVED("no");
    Unsaved_Data_Checker({});
  }

  return disabled;
}

function showListMaker(dayData) {
  let result = [];
  dayData = dayData[0];
  result = [
    { meal: "breakfast", food: dayData["breakfast"] },
    { meal: "lunch", food: dayData["lunch"] },
    { meal: "dinner", food: dayData["dinner"] },
    { meal: "supper", food: dayData["supper"] },
    { meal: "snack1", food: dayData["snack1"] },
    { meal: "snack2", food: dayData["snack2"] },
    { meal: "snack3", food: dayData["snack3"] },
  ];
  let newList = [];
  result.forEach((item) => {
    if (item.food) {
      item.food.forEach((foodItem) => {
        newList.push({ food: foodItem, meal: item.meal });
      });
    }
  });
  return newList;
}

function unsavedData() {
  // if (state.contData.category && state.contData.category !== null || state.barcode) {
  let vAlertMessages = {
    title: i18n.t("meal_planner.UNSAVED_MEAL_PLAN_DATA_TITLE"),
    text: i18n.t("meal_planner.UNSAVED_MEAL_PLAN_DATA_TEXT"),
    logout_text: i18n.t("meal_planner.UNSAVED_MEAL_PLAN_DATA_TEXT_LOGOUT"),
    positiveBtnText: i18n.t("general.POSITIVE_PROMPT_TEXT"),
    page: "meal_planner",
  };
  Unsaved_Data_Checker(vAlertMessages);
}

// Recipe reducer
function reducer(state = initialState, action) {
  function unsavedDataChecker(is_unsave = false) {
    // if (state.contData.category && state.contData.category !== null || state.barcode) {
    if (state.mealListAll.length > 0 || is_unsave) {
      IS_UNSAVED("yes");
      unsavedData();
    } else {
      IS_UNSAVED("no");
      Unsaved_Data_Checker({});
    }
  }

  switch (action.type) {
    case getStarted(MEAL_PLANNER_INITIALIZATION):
    case getSucceeded(MEAL_PLANNER_INITIALIZATION):
      let defaultData = localStorage.getItem("contDefault");
      let defaultVal = JSON.parse(defaultData);
      if (action.payload.isEditing) {
        state.mealPlannerForm.meals = "all";
        state.mealPlannerForm.time = moment(action.payload.date);
        let loadedPlan = action.payload.data;
        state.mealListAll = showListMaker(loadedPlan);
        state.planId = loadedPlan[0]._id;
      } else {
        if (action.payload.date) {
          state.mealPlannerForm.meals = "all";
          state.mealPlannerForm.time = moment(action.payload.date);
        } else {
          state.mealPlannerForm.meals = undefined;
          state.mealPlannerForm.time = undefined;
        }
      }
      if (action.payload.nutrientsList) {
        state.nutritionsList = showingNutrientsArea(
          action.payload.nutrientsList,
          state.mealListAll
        );
      }
      if (defaultVal) {
        state.ingredientList = defaultVal.ingredientList;
        state.mealPlannerForm = defaultVal.mealPlannerForm;
        state.mealPlannerForm.time = moment(defaultVal.mealPlannerForm.time);
        state.mealPlannerForm.upc = defaultVal.barcode;
        state.mealPlannerForm.newMeal = defaultVal.fullname ? defaultVal.fullname : defaultVal.name;
        state.mealPlannerForm.is_custom = defaultVal.mealPlannerForm.is_custom;
        state.mealPlannerForm.category = defaultVal.category;
        state.mealPlannerForm.selectedFood = {};
        state.mealPlannerForm.selectedFood.recipe = defaultVal.name;
        state.mealPlannerForm.selectedFood.recipe_full = defaultVal.fullname ? defaultVal.fullname : defaultVal.name;
        state.mealPlannerForm.selectedFood.upc = defaultVal.barcode;
        state.mealPlannerForm.selectedFood.is_custom = defaultVal.is_custom;
        state.mealPlannerForm.contCategory = defaultVal.category;
        state.mealListAll = defaultVal.mealListAll;
        state.is_custom = defaultVal.is_custom;
        state.firstChange = defaultVal.firstChange;
        state.disabled = defaultVal.disabled;
        state.servingSize = defaultVal.servingSize;
        state.nutritionsList = showingNutrientsArea(
          defaultVal.nutritionsList,
          defaultVal.mealListAll
        );
        if (defaultVal.planId) state.planId = defaultVal.planId;
      }
      return {
        ...state,
        BaseNutrientsList: defaultData
          ? defaultVal.nutritionsList
          : action.payload.nutrientsList,
        updateMode: defaultData
          ? defaultVal.updateMode
          : action.payload.isEditing,
        mealListShow: defaultData
          ? defaultVal.mealListShow
          : showingGrid(state.mealListAll, state.mealPlannerForm.meals),
        counterState: defaultData
          ? defaultVal.counterState
          : state.counterState + 1,
      };
    case getFailed(MEAL_PLANNER_INITIALIZATION):
    case getEnded(MEAL_PLANNER_INITIALIZATION):
      return {
        ...state,
        isLoading: false,
        disabled: disableChecker(state),
      };
    case ON_CHANGE_MEALPLANNERFORM: {
      const { name, value } = action.event.target;
      // Base cloning
      const prevForm = state.mealPlannerForm;
      let newForm = { ...prevForm };
      let newMealList = [...state.mealListAll];
      let newState = {
        ...state,
        partialResult: [],
        counterState: state.counterState + 1,
      };

      // Helper to recompute dependent slices
      const finalize = () => {
        const disabled = !newState.replaceValertShowStatus
          ? disableChecker({ ...newState, mealPlannerForm: newForm })
          : newState.disabled;
        return {
          ...newState,
          mealPlannerForm: { ...newForm, counterState: newForm.counterState + 1 },
          disabled,
          mealListShow: showingGrid(newMealList, newForm.meals),
          mealListAll: newMealList,
          nutritionsList: showingNutrientsArea(state.BaseNutrientsList, newMealList),
          incorrectBarcodeCategory: state.incorrectBarcodeCategory,
        };
      };

      // TIME
      if (name == "time") {
        const prev = prevForm.time;
        newState = {
          ...newState,
          previousTime: moment(prev),
          previousDate: prev,
          previousUpdateMode: state.updateMode,
          previousMeal: prevForm.meals,
          servingSize: showServingSize(newMealList),
          previousMealPlannerForm: prevForm,
          previousNewMeal: prevForm.newMeal,
          firstChange: false,
          previousDisabled: { ...state.disabled },
        };
        if (action.data) {
          const plan = action.data;
          newState.planId = plan[0]._id;
          if (newMealList.length > 0) {
            newState.replaceValertShowStatus = true;
            newState.loadedMealList = showListMaker(plan);
            newState.selectedTime = value;
            newForm.time = newState.previousDate;
          } else {
            newMealList = showListMaker(plan);
            newState.updateMode = true;
            newForm = { ...newForm, meals: "all", newMeal: "", upc: "" };
            newState.disabled = { ...state.disabled, addBtn: true };
          }
        } else {
          newState = { ...newState, updateMode: false, planId: undefined };
          if (newMealList.length > 0) unsavedDataChecker();
          newForm = { ...newForm, meals: "all", newMeal: "", upc: "" };
          newState.disabled = { ...state.disabled, addBtn: true };
        }
      }

      // Only update simple fields when not replacing
      if (!newState.replaceValertShowStatus) newForm[name] = value;

      // NEW MEAL
      if (name == "newMeal") {
        const hasUpc = prevForm.selectedFood && prevForm.selectedFood.upc;
        newForm = {
          ...newForm,
          upc: hasUpc && !action.event.target.upc_clear ? prevForm.upc : "",
          newMeal: value,
          contCategory: hasUpc ? prevForm.contCategory : "",
          selectedFood: {
            _id: hasUpc && !action.event.target.upc_clear ? prevForm.selectedFood._id : "",
            recipe: value,
            recipe_full: value,
            is_custom: !(hasUpc && !action.event.target.upc_clear),
            upc: hasUpc && !action.event.target.upc_clear ? prevForm.upc : "",
          },
        };
        if (action.event.target.contributeRedirectionAlert) newState.contributeRedirectionAlert = false;
      }

      // ADD MEAL PLAN
      else if (name == "addMealPlan") {
        const { _id, show_prompt, number_of_contribute, category, upc, recipe_full, is_custom: orig } = action.data;
        // newState.itemInVerAutofill = show_prompt && number_of_contribute >= 4 && (category == "02" || category == "06");
        let selectedFood = { ...action.data, is_custom: true, upc };
        const itemID = _id.slice(0, 1);
        if (itemID == "1") selectedFood.upc = "";
        if (itemID == "1" || ((itemID == "6" || _id == "") && upc) || !orig) {
          selectedFood.is_custom = false;
        }
        newForm = { ...newForm, _id, newMeal: recipe_full, upc: selectedFood.upc, selectedFood };
      }

      // CHANGE CATEGORY
      else if (name == "changeMealCategory") {
        const { _id, title, recipe_full, upc, is_custom, isOwn } = action.data;
        newForm = {
          ...newForm,
          _id,
          newMeal: recipe_full,
          upc: (is_custom || upc) || (upc && isOwn) ? upc : newForm.upc,
          selectedFood: { _id, recipe: title, recipe_full: title, is_custom: false, upc },
        };
      }

      // MEALS SELECT
      else if (name == "meals") {
        newForm = { ...newForm, newMeal: "", upc: "" };
        newMealList = newMealList.map(item => ({ ...item, isSelected: false }));
        newState = { ...newState, is_custom: false, servingSize: 0 };
      }

      // UPC TO FIELD
      else if (name == "upcToField") {
        newForm = {
          ...newForm,
          upc: state.item_barcode,
          selectedFood: { upc: state.item_barcode },
        };
        if (action.event.target.contributeRedirectionAlert) newState.contributeRedirectionAlert = false;
      }

      // CLEAR
      else if (name == "clearField") {
        newForm = { ...newForm, newMeal: "", recipe: "", recipe_full: "", upc: "", _id: "", contCategory: "", selectedFood: {} };
      }

      // Reset newMeal for null
      if (newForm.meals == "null") newForm.newMeal = "";

      return finalize();
    }
    case ADD_NEW_FOOD_MEAL_PLANNER:
      if (
        state.mealPlannerForm.selectedFood &&
        state.mealPlannerForm.selectedFood.items &&
        state.mealPlannerForm.selectedFood.items.length > 0
      ) {
        state.mealPlannerForm.selectedFood.items.map((item) => {
          state.mealListAll.push({
            food: item,
            meal: state.mealPlannerForm.meals,
            check: action.extra,
          });
        });
      } else {
        // Determine whether it's custom or RefDB
        let formItem = state.mealPlannerForm.selectedFood

        const isCustom =
          (!formItem._id || formItem._id.length === 0) &&
          (!formItem.upc || formItem.upc.length === 0);

        formItem.recipe_full = formItem.recipe_full.replace(/\s+/g, " ").trim(); // Remove double space and trailing space

        if (isCustom) {
          const CaseInsensitiveName = formItem.recipe_full.toLowerCase();

          if (CaseInsensitiveName.endsWith(" (c)")) {
            // If ends with " (C)", remove the space before (C)
            formItem.recipe_full = formItem.recipe_full.slice(0, -4) + " (C)";
          } else if (CaseInsensitiveName.endsWith("(c)")) {
            // if there's "(C)", just remove and add back. This handles the case of switching lower case "(c)" adding by user (if any) to the standard upper case "(C)"
            formItem.recipe_full = formItem.recipe_full.slice(0, -3) + " (C)";
          } else if (!CaseInsensitiveName.endsWith("(c)")) {
            // If there's no "(C)", append "(C)"
            formItem.recipe_full += " (C)";
          }
          formItem.recipe = formItem.recipe_full;
          formItem.recipe = formItem.recipe_full;
        }

        state.mealListAll.push({
          food: state.mealPlannerForm.selectedFood,
          meal: state.mealPlannerForm.meals,
          check: action.extra,
        });
      }
      state.firstChange = true;
      let form = {
        ...state.mealPlannerForm,
        _id: undefined,
        newMeal: "",
        contCategory: "",
        selectedFood: {},
        addMealPlan: {},
        disabled: disableChecker(state),
        upc: undefined,
      };
      state.mealPlannerForm = form;
      unsavedDataChecker();
      return {
        ...state,
        typeAheadSearchOptions: [],
        disabled: disableChecker(state),
        mealListShow: showingGrid(
          state.mealListAll,
          state.mealPlannerForm.meals
        ),
      };
    case MEAL_ITEM_CLICK_MEALPALNNER:
      state.mealListAll.forEach((item) => {
        if (item.vId == action.vId) {
          item.isSelected = !item.isSelected;
        }
      });
      return {
        ...state,
        mealListShow: showingGrid(
          state.mealListAll,
          state.mealPlannerForm.meals
        ),
        nutritionsList: showingNutrientsArea(
          state.BaseNutrientsList,
          state.mealListAll
        ),
        disabled: disableChecker(state),
        servingSize: showServingSize(state.mealListAll),
        is_custom: hasCustom(state.mealListAll),
        counterState: state.counterState + 1,
      };
    case DELETE_FOOD_MEAL_PLANNER:
      const filtered = state.previousSelectedItems.filter(
        (item) => item.vId != action.vId
      );
      state.mealListAll = filtered;
      state.firstChange = true;
      state.servingSize = showServingSize(state.mealListAll);
      unsavedDataChecker();
      return {
        ...state,
        disabled: disableChecker(state),
        mealListShow: showingGrid(
          state.mealListAll,
          state.mealPlannerForm.meals
        ),
        nutritionsList: showingNutrientsArea(
          state.BaseNutrientsList,
          state.mealListAll
        ),
        counterState: state.counterState + 1,
        is_custom: hasCustom(state.mealListAll),
        // firstChange: true,
      };
    case getStarted(ADD_UPDATE_MEAL_PLANNER):
      return { ...state, isLoading: true, saveError: { type: null, meta: [] } };
    case getSucceeded(ADD_UPDATE_MEAL_PLANNER):
        localStorage.removeItem("contDefault");
      // const redirectTime = moment(action.payload.time).format("YYYY-MM-DD");
      setTimeout(() => {
        //window.location.href = `/mealplansummary/${redirectTime}`;
        window.location.href = `/mealplanner/`;
      }, 2000);
      return { ...state, saveSuccess: true };
    case getFailed(ADD_UPDATE_MEAL_PLANNER): {
      const { message, meta } = action.error || {};

      let type = null;
      if (message === "name already exists") {
        type = "alreadyUsedRecipeName";
      }

      // 🔑 normalize meta to string[]
      const normalizedMeta = Array.isArray(meta)
        ? meta
            .map(m =>
              typeof m === "string"
                ? m
                : (m && m.name) || (m && m.label) || ""
            )
            .filter(Boolean)
        : [];

      return {
        ...state,
        isLoading: false,
        saveError: {
          type,
          meta: normalizedMeta,
        },
      };


    }

    case getEnded(ADD_UPDATE_MEAL_PLANNER):
      return { ...state, isLoading: false };

    case TOGGLE_UNSAVE_MESSAGE:
      return { ...state, saveError: { type: null, meta: [] } };
    case LIST_COMBINE_MEAL_PLANNER:
      if (action.status == "combine") {
        state.mealListAll = [...state.loadedMealList, ...state.mealListAll];
        state.firstChange = true;
        state.updateMode = true;
        state.mealPlannerForm = {}
        state.mealPlannerForm.meals = "all";
        state.mealPlannerForm.upc = "";
        state.mealPlannerForm.time = moment(state.selectedTime);
        state.mealListAll.forEach((item) => {
          item.isSelected = false;
        });
        state.servingSize = 0;
        state.is_custom = false;
        state.disabled = disableChecker(state);
      } else if (action.status == "replace") {
        // state.mealListAll = state.loadedMealList;
        state.firstChange = true;
        state.updateMode = true;
        state.mealPlannerForm = {}
        state.mealPlannerForm.meals = "all";
        state.mealListAll.forEach((item) => {
          item.isSelected = false;
        });
        state.servingSize = 0;
        state.is_custom = false;
        state.mealPlannerForm.time = moment(state.selectedTime);
        state.mealPlannerForm.upc = "";
        state.disabled = disableChecker(state);
      } else {
        state.mealPlannerForm = state.previousMealPlannerForm;
        state.mealPlannerForm.time = state.previousTime;
        state.mealPlannerForm.meals = state.previousMeal;
        state.mealPlannerForm.newMeal = state.previousNewMeal;
        state.updateMode = state.previousUpdateMode;
        state.disabled = state.previousDisabled;
        state.firstChange =
          (state.previousUpdateMode && !state.previousDisabled.updatePageBtn) ||
            (!state.previousUpdateMode && !state.previousDisabled.savePageBtn)
            ? true
            : false;
        state.disabled = disableChecker(state);
      }
      state.replaceValertShowStatus = false;
      return {
        ...state,
        mealListShow: showingGrid(
          state.mealListAll,
          state.mealPlannerForm.meals
        ),
        nutritionsList: showingNutrientsArea(
          state.BaseNutrientsList,
          state.mealListAll
        ),
        counterState: state.counterState + 1,
        selectedTime: "",
      };
    case getStarted(MEAL_PLAN_PAGE_BARCODE_READ):
      state.itemInVerAutofill = false;
      return {
        ...state,
        isLoading: true,
        upc404: false,
        barcodeCategoryRef: false,
        incorrectBarcodeCategory: false,
        refdb_item: false,
        refdb_item_category: "",
        barcodeRead: false,
        amountReseter: !state.amountReseter,
      };
    case getSucceeded(MEAL_PLAN_PAGE_BARCODE_READ):
      state.amountReseter = !state.amountReseter;

      const updateMealPlannerForm = (data) => {
        state.mealPlannerForm = {
          ...state.mealPlannerForm,
          recipe_full: data.title,
          recipes: data.title,
          recipe: data.title,
          full_name: data.title,
          upc: data.upc || "",
          _id: data._id,
        };
      };


      const {
        category,
        is_ref,
        is_own,
        is_history,
        upc,
        number_of_contribute,
        show_prompt,
      } = action.data;


      // -------- Non-RefDB ITEM --------
      if (!is_ref) {
        // -------- Item in Verification/Incorrect Category/Incompatible Category --------
        if (show_prompt && number_of_contribute >= 4) {
          // -------- history = false --------
          if (!is_history) {
            if (is_own && (category !== "02" && category !== "06")) {
              // own → incorrect category first
              state.incorrectBarcodeCategory = true;
              state.itemData = action.data;
              // state.itemData.setRef = true;
              
              state.showVerificationPrompt = true; // flag to trigger Item in Verification upon positive action
            } else {
              state.itemInVerAutofill = true;
            }
          }

          // -------- history = true --------
          else {
            if (category !== "02" && category !== "06") {
              // mismatch → incompatible category ONLY
              state.barcodeCategoryRef = true;
              state.refdb_item = false;
              const categories = i18n.t("CATEGORIES", { returnObjects: true });
              let categoryItem = categories.find((item) => item.value === category);
              state.refdb_item_category = categoryItem ? categoryItem.label : "";
              state.itemData = action.data;
              // state.itemData.setRef = true;              
            } else {
              state.itemInVerAutofill = true;            
            }
          }
        }

        // -------- Incorrect Category/Incompatible Category --------
        else if (number_of_contribute >= 4) {
          // -------- history = false --------
          if (!is_history) {
            if (is_own && (category !== "02" && category !== "06")) {
              state.incorrectBarcodeCategory = true;
              state.itemData = action.data;
              // state.itemData.setRef = true
            } else {
              updateMealPlannerForm(action.data);
            }
          }

          // -------- history = true --------
          else {
            if (category !== "02" && category !== "06") {
              state.barcodeCategoryRef = true;
              state.refdb_item = false;
              const categories = i18n.t("CATEGORIES", { returnObjects: true });
              let categoryItem = categories.find((item) => item.value === category);
              state.refdb_item_category = categoryItem ? categoryItem.label : "";
              state.itemData = action.data;
              // state.itemData.setRef = true;
            } else {
              updateMealPlannerForm(action.data);
            }
          }
        }

        // -------- Product not in 12u12 DB/Incorrect Category/Incompatible Category --------
        else if (number_of_contribute < 4) {
          // -------- history = false --------
          if (!is_history) {
            if (!is_own) {
              state.contributeRedirectionAlert = true;
              state.upc404 = true;
              let listingObject = i18n.t("BARCODE.UPC404_ERROR_TEXT.LISTING", {
                returnObjects: true,
              });
              state.listings = Object.entries(listingObject).map(([key, value]) => ({
                key,
                value,
              }));
              state.item_barcode = action.data.upc;
            } else if (category !== "02" && category !== "06") {
              state.incorrectBarcodeCategory = true;
              state.itemData = action.data;
              // state.itemData.setRef = true
            } else {
              updateMealPlannerForm(action.data);
            }
          }

          // -------- history = true --------
          else {
            if (category !== "02" && category !== "06") {
              state.barcodeCategoryRef = true;
              state.refdb_item = false;
              const categories = i18n.t("CATEGORIES", { returnObjects: true });
              let categoryItem = categories.find((item) => item.value === category);
              state.refdb_item_category = categoryItem ? categoryItem.label : "";
              state.itemData = action.data;
              // state.itemData.setRef = true;
            } else {
              updateMealPlannerForm(action.data);
            }
          }
        }
      } 
      
      // -------- RefDB ITEM --------
      else {
        if (category !== "02" && category !== "06") {
          state.barcodeCategoryRef = true;
          state.refdb_item = true;
          const categories = i18n.t("CATEGORIES", { returnObjects: true });
          let categoryItem = categories.find((item) => item.value === category);
          state.refdb_item_category = categoryItem ? categoryItem.label : "";
          state.itemData = action.data;
        } else {
          action.data.upc = "";
          updateMealPlannerForm(action.data);
          state.barcodeRead = true;
        }
      }

      // // Group 02 and 06 categories with common logic
      // if (
      //   number_of_contribute >= 4 &&
      //   !is_ref &&
      //   !is_own &&
      //   !is_history &&
      //   show_prompt
      // ) {
      // } else if (
      //   number_of_contribute < 4 &&
      //   !is_ref &&
      //   !is_own &&
      //   !is_history &&
      //   !show_prompt
      // ) {
      //   state.contributeRedirectionAlert = true;
      //   // Convert listing object to array
      //   let listingObject = i18n.t("BARCODE.UPC404_ERROR_TEXT.LISTING", {
      //     returnObjects: true,
      //   });
      //   state.listings = Object.entries(listingObject).map(([key, value]) => ({
      //     key,
      //     value,
      //   }));
      //   state.item_barcode = action.data.upc;
      // } else if (
      //   number_of_contribute >= 4 &&
      //   !is_ref &&
      //   !is_own &&
      //   !is_history &&
      //   !show_prompt
      // ) {
      //   updateMealPlannerForm(action.data);
      // } else if (category === "02" || category === "06") {
      //   if (is_ref) {
      //     action.data.upc = "";
      //     updateMealPlannerForm(action.data);
      //     state.barcodeRead = true;
      //   } else if (is_own && !show_prompt) {
      //     updateMealPlannerForm(action.data);
      //   } else if (!is_ref && !is_own && is_history) {
      //     updateMealPlannerForm(action.data);
      //   } else if (number_of_contribute >= 4 && show_prompt) {
      //     state.itemInVerAutofill = true;
      //   }
      // } else {
      //   if (is_ref) {
      //     state.barcodeCategoryRef = true;
      //     state.refdb_item = true;
      //     // Cache i18n call
      //     const categories = i18n.t("CATEGORIES", { returnObjects: true });
      //     let categoryItem = categories.find((item) => item.value === category);
      //     state.refdb_item_category = categoryItem ? categoryItem.label : "";
      //   } else if (is_history) {
      //     state.barcodeCategoryRef = true;
      //     state.refdb_item = false;
      //     state.itemData = action.data;
      //   } else if (is_own) {
      //     state.incorrectBarcodeCategory = true;
      //     state.itemData = action.data;
      //   }
      // }

      // Reset amounNewValue and kitdata
      state.amounNewValue = "";
      state.kitdata = [];
      return {
        ...state,
        isLoading: false,
        barcodeRead: true,
      };
    case getEnded(MEAL_PLAN_PAGE_BARCODE_READ):
      unsavedDataChecker();
      return {
        ...state,
        isLoading: false,
        barcodeRead: true,
      };
    case getFailed(MEAL_PLAN_PAGE_BARCODE_READ):
      state.contributeRedirectionAlert = true;
      let listingObject = i18n.t("BARCODE.UPC404_ERROR_TEXT.LISTING", {
        returnObjects: true,
      });
      state.listings = Object.entries(listingObject).map(([key, value]) => ({
        key,
        value,
      }));
      state.item_barcode = action.upc;
      state.barcode = action.upc;
      state.mealPlannerForm.selectedFood = {};
      // state.symptomEditForm.name = "[" + action.upc + "]";
      return { ...state, isLoading: false };
    case getStarted(MEAL_PLAN_PAGE_BARCODE_READ_IMG):
      state.itemInVerAutofill = false;
      return { ...state, barcodeFailed: false, isLoading: true };
    case getSucceeded(MEAL_PLAN_PAGE_BARCODE_READ_IMG):
      return { ...state, isLoading: false };
    case getFailed(MEAL_PLAN_PAGE_BARCODE_READ_IMG):
      return { ...state, barcodeFailed: true, isLoading: false };
    case getSucceeded(PARTIAL_RESULT_FOUND):
      let getResult = action.partialSearch;
      return {
        ...state,
        partialResult: getResult,
      };
    case getFailed(PARTIAL_RESULT_FOUND):
      return {
        ...state,
        barcodeValue: action.upc,
        addCustomAlert: true,
      };
    case CLEAR_MEALPLANNER_FORM:
      state.mealPlannerForm = {};
      localStorage.removeItem("contDefault");
      localStorage.removeItem("unContributed");
      return { ...state, isLoading: false };

    case getStarted(GET_ITEM_DETAILS):
      return { ...state, isLoading: true };
    case getSucceeded(GET_ITEM_DETAILS):
      state.mealPlannerForm = {};
      return { ...state, isLoading: false };
    case getFailed(GET_ITEM_DETAILS):
      return { ...state, isLoading: false };
    case ON_CHANGE_ALERT_STATUS:
      state.addCustomAlert = false;
      if (action.data.addCustomAlert) {
        state.addCustomAlert = !!action.data.addCustomAlert;
      }
      return {
        ...state,
        ...action.data,
      };
    case ON_SELECT_ITEM_TO_DELETE:
      let { previousSelectedItems, mealListAll } = state;

      if (action.is_delete) {
        previousSelectedItems = [...mealListAll];
      }
      const hasSelectedItems = mealListAll.some((item) => item.isSelected);
      mealListAll =
        action.is_delete && hasSelectedItems
          ? mealListAll.map((item) => ({
            ...item,
            isSelected: item.vId == action.id,
          }))
          : [...previousSelectedItems];

      if (!action.is_delete) {
        previousSelectedItems = [];
      }

      return {
        ...state,
        previousSelectedItems,
        mealListAll,
        mealListShow: showingGrid(mealListAll, state.mealPlannerForm.meals),
        nutritionsList: showingNutrientsArea(
          state.BaseNutrientsList,
          mealListAll
        ),
        servingSize: showServingSize(mealListAll),
      };
    case CLEAR_PLANNER:
      localStorage.removeItem("contDefault");
      localStorage.removeItem("unContributed");
      return {
        ...state,
        saveSuccess: false,
      };
    case RESET_CONTRIBUTE_ALERT_STATE:
      state.contributeRedirectionAlert = false;
      state.upc404 = false;
      return { ...state };
    case ADD_GREY_UPC_ITEM_NAME_FIELD:
      state.mealPlannerForm = {
        ...state.mealPlannerForm,
        upc: action.payload,
      };
      return { ...state };

    case MEAL_PLANNER_SET_LOADING:
      return {
        ...state,
        isLoading: !!action.isLoading,
      };

    default:
      return state;
  }
}
export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/mealPlannerReducer.js